import { PasswordConfig } from "../models/SecurityPolicyPasswordConfig";
import { getDefaultSecurityPolicyId, getSecurityPolicyById } from "../services/securityPolicyService";

export class SecurityPolicyPasswordConfigHelper {
    static async fetchAssignedUserSecurityPolicyPasswordConfig(userSecurityPolicyId: number, translate): Promise<PasswordConfig | null> {
        const assignedPolicyId: string | null = userSecurityPolicyId && userSecurityPolicyId !== 0 ? userSecurityPolicyId + "" : null;

        if (!assignedPolicyId) {
            return null;
        }

        return this.fetchPasswordConfigForPolicyId(assignedPolicyId, translate);
    }

    static async fetchSecurityPolicyPasswordConfig(securityPolicyId: number, translate): Promise<PasswordConfig | null> {
        let resolvedId: string | null = securityPolicyId && securityPolicyId !== 0 ? securityPolicyId + "" : null;

        if (!resolvedId) {
            resolvedId = await getDefaultSecurityPolicyId();
        }

        if (!resolvedId) {
            return null;
        }

        return this.fetchPasswordConfigForPolicyId(resolvedId, translate);
    }

    private static async fetchPasswordConfigForPolicyId(securityPolicyId: string, translate): Promise<PasswordConfig> {
        const securityPolicy = await getSecurityPolicyById(securityPolicyId, translate);
        return {
            enforceUppercase: securityPolicy.enforceUppercase,
            enforceLowercase: securityPolicy.enforceLowercase,
            enforceDigits: securityPolicy.enforceDigits,
            enforceSpecialCharacters: securityPolicy.enforceSpecialCharacters,
            enforcePasswordMinLength: securityPolicy.enforcePasswordMinLength,
            passwordMinLength: securityPolicy.passwordMinLength,
        };
    }
}
